import {
  __esm,
  __spreadValues
} from "./chunk-ZU6LNBSF.mjs";

// src/icons/EyeOffFilled.tsx
import React from "react";
var SvgEyeOffFilled, EyeOffFilled_default;
var init_EyeOffFilled = __esm({
  "src/icons/EyeOffFilled.tsx"() {
    SvgEyeOffFilled = (props) => /* @__PURE__ */ React.createElement(
      "svg",
      __spreadValues({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
      }, props),
      /* @__PURE__ */ React.createElement(
        "path",
        {
          fill: "currentColor",
          d: "M4.52 5.934 1.393 2.808l1.415-1.415 19.799 19.8-1.415 1.414-3.31-3.31A10.948 10.948 0 0 1 12 21c-5.392 0-9.878-3.88-10.819-9a10.982 10.982 0 0 1 3.34-6.066H4.52Zm10.237 10.238-1.464-1.464a3 3 0 0 1-4.001-4.001L7.828 9.243a5 5 0 0 0 6.929 6.929ZM7.974 3.76C9.221 3.27 10.58 3 12 3c5.392 0 9.878 3.88 10.819 9a10.946 10.946 0 0 1-2.012 4.592l-3.86-3.86a5 5 0 0 0-5.68-5.68L7.974 3.76V3.76Z"
        }
      )
    );
    EyeOffFilled_default = SvgEyeOffFilled;
  }
});

export {
  EyeOffFilled_default,
  init_EyeOffFilled
};
